import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=35cb50ad&scoped=true&"
import script from "./Blog.vue?vue&type=script&lang=ts&"
export * from "./Blog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb50ad",
  null
  
)

export default component.exports